import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';

/**
 * Route guard that requires authentication AND one of the allowed roles.
 * Deny by default: anonymous users are redirected to login; a signed-in user
 * without an allowed role is blocked (sent to 403), not merely hidden.
 *
 *   <Route element={<RoleRoute roles={['connector', 'admin']} />}>
 *     <Route path="connector-onboarding" element={<Onboarding />} />
 *   </Route>
 */
export default function RoleRoute({ roles = [] }) {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading…</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (roles.length > 0 && !roles.includes(user?.role)) {
    return <Navigate to="/403" replace />;
  }

  return <Outlet />;
}
